import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { DefaultInfoHeaderIcons } from 'src/app/shared/utility/svg-constants';
import { menuItems } from 'src/app/shared/models/sidebar.model';
import { CommonService } from 'src/app/shared/services/common.service';
import { SearchService } from '../../search/search.service';
import { RpeRuntimeBridgeService } from 'src/app/shared/services/rpe-runtime-bridge.service';
import { UserService } from 'src/app/features/service/user.service';
import { MenuItem } from 'src/app/shared/models/sidebar.model';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly rpeRuntimeBridge = inject(RpeRuntimeBridgeService);
  isExpanded: boolean = false;
  activeRoute: any | null = null;
  public hawbInfoHeaderIcons = DefaultInfoHeaderIcons;
  public menuItems: MenuItem[] = menuItems;
  public visibleMenuItems: MenuItem[] = menuItems;
  pressedButtonIndex: number | null = null;

  constructor(
    private readonly router: Router,
    private readonly commonService: CommonService,
    private readonly searchService: SearchService,
    private readonly userService: UserService
  ) {}

  ngOnInit() {
    this.refreshVisibleMenuItems();

    this.rpeRuntimeBridge.contextRefresh$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.refreshVisibleMenuItems();
      });

    this.userService.userProfileInfo
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.refreshVisibleMenuItems();
      });

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.activeRoute = this.extractRouteSegment(this.router.url);
        const menuItemIndex = this.visibleMenuItems.findIndex(menuItem => {
          return menuItem.routerLink.indexOf(this.activeRoute) !== -1;
        });
        if (menuItemIndex !== -1) {
          this.onButtonClick(menuItemIndex, false);
        }
      });
  }

  public toggleSidenav() {
    this.isExpanded = !this.isExpanded;
    setTimeout(() => {
      this.commonService.getMenuExpanded(this.isExpanded);
    }, 100);
  }

  public onButtonClick(index: number, clearPayload = true) {
    if (clearPayload) {
      this.commonService.clearLastUsedPayload();
    }
    this.pressedButtonIndex = index;
    this.searchService.setClickedHyperlinkData({});
  }


  private refreshVisibleMenuItems(): void {
    this.visibleMenuItems = this.menuItems.filter((item) =>
      this.rpeRuntimeBridge.isMenuItemVisible(item.routerLink)
    );
  }

  private extractRouteSegment(url: string): string {
    const segments = url.split('/');
    return segments[1] || '';
  }
}
